import React from "react";
import PropTypes from "prop-types";

const Background = (props) => {
  const { style: propStyle, children, isActive, size } = props;

  const fillerExtraStyle = {
    height: isActive ? "100%" : "0%",
    width: isActive ? "100%" : "0%",
  };

  const sizeStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <div style={{ ...styles.container, ...sizeStyle }}>
      <div style={{ ...styles.filler, ...propStyle, ...fillerExtraStyle }} />
      <div style={styles.childrenContainer}>{children}</div>
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.5s",
  },
  filler: {
    position: "absolute",
    transition: "all 0.5s",
  },
  childrenContainer: {
    zIndex: 1,
  },
};

Background.propTypes = {
  style: PropTypes.shape(),
  children: PropTypes.element.isRequired,
  isActive: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired,
};

export default Background;
